<template>
  <v-layout column text-center align-center justify-center>
    <p class="display-3 mt-12 primary--text">
      You are not logged in
    </p>
    <v-btn solid
           dark 
           large 
           color="accent" 
           to="/about" 
           width="200"
           class="ma-2">What is this?</v-btn>
    <v-layout :column="$vuetify.breakpoint.xs" justify-center align-center>
      <v-btn solid 
             large 
             color="secondary" 
             to="/login" 
             width="200"
             class="ma-2">Log in now</v-btn>
      <v-btn solid 
             large 
             color="primary" 
             to="/register" 
             width="200"
             class="ma-2">Create an account</v-btn>
    </v-layout>
  </v-layout>
</template>

<script>
  export default {

  };
</script>
